export const EDIT_SPACE_GROUP_MODAL_TAB = {
  DETAILS: "Details",
  MEMBERS: "Members",
} as const;

export type EditSpaceGroupModalTab =
  (typeof EDIT_SPACE_GROUP_MODAL_TAB)[keyof typeof EDIT_SPACE_GROUP_MODAL_TAB];

export const EDIT_SPACE_GROUP_MODAL_COMPASS_TAB = {
  DETAILS: "details",
  MEMBERS: "members",
} as const;

export type EditSpaceGroupModalCompassTab =
  (typeof EDIT_SPACE_GROUP_MODAL_COMPASS_TAB)[keyof typeof EDIT_SPACE_GROUP_MODAL_COMPASS_TAB];

export const editSpaceGroupModalTabToCompassTab = (
  tab: EditSpaceGroupModalTab,
): EditSpaceGroupModalCompassTab =>
  tab === EDIT_SPACE_GROUP_MODAL_TAB.MEMBERS
    ? EDIT_SPACE_GROUP_MODAL_COMPASS_TAB.MEMBERS
    : EDIT_SPACE_GROUP_MODAL_COMPASS_TAB.DETAILS;
